export function getDistanceBetweenPoints(location1, location2): number {
  const { lat: lat1, lng: lon1 } = location1
  const { lat: lat2, lng: lon2 } = location2
  const R = 6371 // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1) // deg2rad below
  const dLon = deg2rad(lon2 - lon1)
  const a
    = Math.sin(dLat / 2) * Math.sin(dLat / 2)
    + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
    * Math.sin(dLon / 2) * Math.sin(dLon / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c // Distance in km
  const miles = 0.621371 * d
  return miles
}

function deg2rad(deg: number) {
  return deg * (Math.PI / 180)
}
